import { FormModal } from 'modules/core/containers';
import { useEffect, useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { v4 as uuid } from 'uuid';
import { connect } from 'react-redux';

import { universalReferenceActions } from '../../../universal-reference/store/universalReferenceStore';
import { insurancePolicyValidationSchema } from '../../validation';
import RefValueSelector
  from '../../../core/components/selectors/RefValueSelector';
import { INSURANCE_TYPE } from '../../../core/constants/refs';
import InsuranceCompanySelect from '../InsuranceCompanySelect';
import { DateTimeInput, StringInput } from '../../../core/components/forms';
import { Policy } from '../../api/policyApi';
import { InsuranceCompany } from '../../../insurances/store/insurancesApi';

export interface VehiclePoliciesModalProps {
  show: boolean,
  policy: Record<string, any>,
  onClose: () => void,

  onCreate: (values: Policy) => void,

  onChange: (values: Policy) => void,
  insuranceCompanies?: InsuranceCompany[],
}

const VehiclePoliciesModal = (props: VehiclePoliciesModalProps) => {
  const {
    show,
    policy,
    onClose,
    onCreate,
    onChange,
    insuranceCompanies,
  } = props;

  const [refValues, setRefValues] = useState([]);

  useEffect(() => {
    universalReferenceActions.getRefValues(INSURANCE_TYPE)
      .then((refValues) => setRefValues(refValues));
  }, []);

  const handleSubmit = async (values: Policy) => {
    const insuranceCompany = insuranceCompanies.find((v) => v.id === values.insuranceCompanyId).name;
    const insuranceType = refValues.find((v) => v.id === values.insuranceTypeRefValueId).name;

    if (!values.id) {
       
      values.id = uuid();
      await onCreate({ ...values, insuranceCompanyName: insuranceCompany, insuranceTypeRefValueName: insuranceType });
    } else {
      await onChange(values);
    }
  };

  const handleClose = () => {
    onClose?.();
  };

  return (
    <FormModal
      show={ show }
      header='Добавление/редактирование полиса'
      initialValues={ policy || {} }
      validationSchema={ insurancePolicyValidationSchema }
      onClose={ handleClose }
      onCancel={ handleClose }
      onSubmit={ handleSubmit }
    >
      <Row>
        <Col md={ 6 }>
          <RefValueSelector
            name='insuranceTypeRefValueId'
            refId={ INSURANCE_TYPE }
            label='Тип полиса'
            placeholder='Тип полиса'
          />
        </Col>
        <Col md={ 6 }>
          <InsuranceCompanySelect
            name='insuranceCompanyId'
            placeholder='Страховая компания'
            label='Страховая компания'
          />
        </Col>
      </Row>
      <Row>
        <Col md={ 12 }>
          <StringInput
            name='insuranceNumber'
            label='Номер полиса/номер договора страхования'
            placeholder='Номер полиса/номер договора страхования'
          />
        </Col>
      </Row>
      <Row>
        <Col md={ 6 }>
          <DateTimeInput
            name='startDate'
            label='Дата начала действия'
            placeholder='Дата начала действия'
            displayFormat='dd.MM.yyyy'
            showTime={ false }
          />
        </Col>
        <Col md={ 6 }>
          <DateTimeInput
            name='expirationDate'
            label='Дата окончания действия'
            placeholder='Дата окончания действия'
            displayFormat='dd.MM.yyyy'
            showTime={ false }
          />
        </Col>
      </Row>
    </FormModal>
  );
};

const mapStateToProps = (state) => ({
  insuranceCompanies: state.insurances.insuranceCompanies,
});

export default connect(mapStateToProps)(VehiclePoliciesModal);
